import { UPDATE_LOCALE } from './actionTypes';

export const updateLocale = (payload: any) => {
    return {
        type: UPDATE_LOCALE,
        payload,
    };
};



// WEBPACK FOOTER //
// ./modules/process-locale-post/actions/actions.ts